<template>
	<div class="zzgk_dialog" style="max-height: 500px;overflow-y: scroll;">
		<el-dialog 
			:modal-append-to-body='true'
			width="500px"
			center
			:append-to-body='true'
			@close="closeWin"
			:visible.sync="addDwdf">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData2">
				<el-form ref="form" :model="formData" class="formWrap" >
					<el-form-item
					:key="index"
					 :label="item.class_name" 
					v-for="(item,index) in tableHeader"
					class="form_item" prop="allocate_class">
						<el-input-number v-model="formData.score[index]" :min="1" :max="parseInt(item.score)"></el-input-number>
					</el-form-item>
					<div class="form_item">
						总分：<input disabled style="border: none;background: none;" type="" name="" id="" :value="total" />
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeWin">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dwgl } from '@/axios'
	let that;
	export default{
		data(){
			return{
				title:"党委打分",
				addDwdf:false,
				formData:{
					score:[]
				},
				id:""
			}
		},
		props:{
			tableHeader:{
				type:Array,
				default:[]
			}
		},
		computed:{
			total(){
				let totals=0;
				for(let i=0;i<this.formData.score.length;i++){
					totals += parseInt(this.formData.score[i]);
				}
				return totals
			}
		},
		created(){that = this;},
		methods:{
			// 打开打分弹窗
			openWin(data){
				that.addDwdf = true;
				that.id = data.id;
				that.bindData(data)
			},
			// 关闭弹窗
			closeWin(){
				that.addDwdf = false;
				that.id = "";
				that.formData.score = [];
			},
			// 打分
			submit(){
				dwgl.scoreGoodMember({
					id:that.id,
					score:that.formData.score.toString(),
					status:1//1：党员2：党务工作者
				}).then(res => {
					if(res.code == 200){
						that.closeWin();
						that.$emit("dataList")
					}
				})
			},
			// 编辑绑定数据
			bindData(data){
				that.formData.score = []
				if(data.res!=""){
					that.formData.score = data.score;
				}else{
					for(let i=0;i<that.tableHeader.length;i++){
						that.formData.score.push(parseInt(that.tableHeader[i].score))
					}
				}
				console.log(data.score)
			},
		}
	}
</script>

<style lang="scss">
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 500px;
		}
	}
	.formData2{
		display: flex;
		justify-content: center;
		width: 100%;
		max-height: 400px;
		overflow-y: scroll;
		.el-form-item{
			display: flex;
			align-items: center;
		}
	}
</style>
